import zipy from 'zipyai';

export const zipyIdentifyUser = (email, userData) => {
  zipy.identify(email, userData);
};

export const zipyAnonymize = () => {
  zipy.anonymize();
};
